import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { CoordinateBoundary } from '@realpage-da/ng-map';

import { ApiBase } from './base-api.service';
import { CacheService } from '~/core/services/cache.service';
import {
  PropertyDetailJSON,
  PropertyAERCOJSON,
  PropertyMetric,
  WalkScoreJSON
} from '~/core/model';

import * as NewModel from '~/core/model/PropertyMetric';
import { RateLimitService } from './rate-limit.service';
import { RequestQueueService } from './request-queue.service';

@Injectable()
export class PropertyService extends ApiBase {

  constructor(protected http: HttpClient, private cacheFactoryApi: CacheService, rateLimitService: RateLimitService, requestQueueService: RequestQueueService) {
    super(http, cacheFactoryApi, rateLimitService, requestQueueService);
  }

  getMarketProperties(marketId: number): Observable<NewModel.PropertyMetric[]> {
    return this.get(`/markets/${marketId}/properties`)
      .map((res: NewModel.PropertyMetricJSON[]) => !!res && res.map(property => new NewModel.PropertyMetric(property)));
  }

  getProperties(bounds: CoordinateBoundary): Observable<PropertyDetailJSON[]> {
    const point = '32.865825,-96.793113'; //To be removed once db team update the SQL function to make point parameter nullable.
    const params = { point, boundingBox: [bounds.southwest.latitude, bounds.southwest.longitude, bounds.northeast.latitude, bounds.northeast.longitude].join(',') };
    return this.post(`/properties/propertydetailsbybounds`, params);
  }

  getPropertyDetails(propertyId: number, position: string, propertyType?: string): Observable<PropertyMetric> {
    return Observable.combineLatest(this.getPropertyInfo(propertyId, position, propertyType), this.getPropertyAerco(propertyId))
      .map(([property, metrics]) => new PropertyMetric(property, metrics));
  }

  getPropertyAerco(propertyId): Observable<PropertyAERCOJSON> {
    return this.get(`/properties/${propertyId}/aerco`)
      .map(metrics => (metrics && metrics.properties && metrics.properties.length && metrics.properties[0]));
  }

  getPropertyInfo(propertyid, position, propertytype): Observable<PropertyDetailJSON> {
    let params: HttpParams = new HttpParams();
    params = params.append('position', position);
    params = params.append('type', propertytype);
    return this.get(`/properties/${propertyid}/detail`, { params: params }, null, false, false)
      .map(data => {
        return data && data[0];
      })
  }

  getWalkScore(address: string, lat: string, lon: string): Observable<WalkScoreJSON> {
    // Need to use the Backend Service instead calling the API directly due to CORS problem.
    // Will update this when CORS configuration is integrated.
    const url = encodeURI(`/properties/walkscore?address=${address}&lat=${lat}&lon=${lon}`);

    return this.get(`${url}`).map(data => {
      if (!!data) {
        return {
          bike: {
            'score': data.bike ? data.bike.score : null, 'description': data.bike ? data.bike.description : null
          },
          transit: {
            'score': data.transit ? data.transit.score : null, 'description': data.transit ? data.transit.description : null
          },
          walk: {
            'score': data.walkscore, 'description': data.description
          }
        };
      } else {
        return {
          bike: {
            'score': null, 'description': ''
          },
          transit: {
            'score': null, 'description': ''
          },
          walk: {
            'score': null, 'description': ''
          }
        };
      }
    });
  }

  getPropertyCurtainDetail(propertyId: number, module: string): Observable<PropertyMetric> {
    return this.get(`/properties/${module}/curtainDetail/${propertyId}`)
      .map(data => {
        return new PropertyMetric(data && data.propertyDetail.length > 0 && data.propertyDetail[0], data && data.metrics && data.metrics.properties.length > 0 && data.metrics.properties[0])
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/property.service.ts